import React from 'react';
import classNames from 'classnames';
import { BringgFontIcons } from '@bringg/bringg-icons';
import { Row, TableInstance } from 'react-table';
import TableHead from './table-head/table-head';
import TableBody from './table-body/table-body';

interface BringgTableProps<D extends object = {}> {
	tableInstance: TableInstance<D>;
	className?: string;
	maxHeight?: number | string;
	expandIconName?: BringgFontIcons;
	customGroupRow?: (subRowsCount) => JSX.Element;
	tableBodyClass?: string;
	tableRowClass?: string;
	tableCellClass?: string;
	tableCellTextClass?: string;
	page?: Array<Row<D>>;
}

const BringgTable = <D extends object = {}>({
	tableInstance,
	className,
	maxHeight,
	expandIconName,
	customGroupRow,
	tableBodyClass,
	tableRowClass,
	tableCellClass,
	tableCellTextClass,
	page
}: BringgTableProps<D>) => {
	const { headerGroups, getTableProps, getTableBodyProps, rows, prepareRow } = tableInstance;
	return (
		<div className={classNames('bringg-table', className)} data-test-id="bringg-table" {...getTableProps()}>
			<TableHead headerGroups={headerGroups} />
			<TableBody
				getTableBodyProps={getTableBodyProps}
				rows={rows}
				page={page}
				prepareRow={prepareRow}
				maxHeight={maxHeight}
				expandIconName={expandIconName}
				customGroupRow={customGroupRow}
				tableBodyClass={tableBodyClass}
				tableRowClass={tableRowClass}
				tableCellClass={tableCellClass}
				tableCellTextClass={tableCellTextClass}
			/>
		</div>
	);
};

export default BringgTable;
